/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';

const brandByDomain = {
    '18F': '1800flowers',
    HD: 'harryanddavid',
    '18B': '1800baskets',
    SCH: 'simplychocolate',
    FBQ: 'fruitbouquets',
    CCO: 'cheryls',
    PZU: 'personalizationuniverse',
    TPF: 'thepopcornfactory',
    WLF: 'wolfermans',
    SY: 'stockyards',
    BRY: 'berries',
    VC: 'vitalchoice',
    FL: 'florists',
};

export const cartStatusCompleteList = ['published', 'placed', 'paid', 'publishfailed', 'testcart'];

export const getCurrentBrandId = (state) => state.ui.brandId;
export const getConfigByDomains = (state) => state.app.config.byDomain;

// Feature Flag
export const getFeatureFlags = createSelector(
    [getCurrentBrandId, getConfigByDomains],
    (currentBrandId, configCodes) => {
        if (
            currentBrandId
            && brandByDomain[currentBrandId]
            && configCodes[brandByDomain[currentBrandId]]
        ) {
            return configCodes[brandByDomain[currentBrandId]][
                'app-feature-flags'
            ];
        }

        return {};
    },
);
